<p><div *ngIf="!isLoading; else spinner">
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="lighting > 0; else addTitle">Edit Lighting</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <fieldset class="fieldset-container">
        <legend>Area Information</legend>
        <p>
          <mat-form-field class="edit-lighting">
            <mat-select placeholder="Lighting Type *" [(value)]="selectedLightingType" name="lightingType" formControlName="lightingType">
              <mat-option value="Approach">Approach</mat-option>
              <mat-option value="Runway End Identifier">Runway End Identifier</mat-option>
              <mat-option value="Runway Visual Range">Runway Visual Range</mat-option>
              <mat-option value="End Touchdown">End Touchdown</mat-option>
              <mat-option value="Visual Glide Slope">Visual Glide Slope</mat-option>
              <mat-option value="Runway Visual Value">Runway Visual Value</mat-option>
              <mat-option value="CenterLine">Center Line</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="edit-lighting">
            <input matInput
                   placeholder="Description"
                   formControlName="description"
                   [(ngModel)]="lighting.description">
          </mat-form-field>
        </p>
      </fieldset>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Lighting
</ng-template>
